import React from 'react'
import { Outlet } from 'react-router-dom'

export const UserManagement = () => {
  return (
    <Outlet />
  )
}
